export default class {
  mp3Worker = new Worker('/js/lame-worker.js');

  convert = async (file: File): Promise<Blob> => {
    return new Promise((resolve: (blob: Blob) => void, reject) => {
      const fileReader = new FileReader();

      fileReader.onload = (pe: ProgressEvent) => {
        this.mp3Worker.postMessage({
          cmd: 'init',
          config: {}
        });

        this.mp3Worker.postMessage({
          cmd: 'encode',
          rawInput: (pe.target as any).result
        });
        this.mp3Worker.postMessage({ cmd: 'finish' });

        this.mp3Worker.onmessage = (e: MessageEvent) => {
          if (e.data.cmd === 'end') {
            var mp3Blob = new Blob(e.data.buf, { type: 'audio/mp3' });
            resolve(mp3Blob);
          } else if (e.data.cmd === 'progress') {
            // console.log(e.data.progress);
          } else if (e.data.cmd === 'error') {
            reject(e.data);
          }
        };
      };
      fileReader.readAsArrayBuffer(file);
    });
  };
}



// WEBPACK FOOTER //
// ./src/audio/MP3Converter.ts